export default __webpack_public_path__ + "static/introduction-video-ed40bb8ee8afe31f73926f5fccbae8c1.mp4";